<template>
  <div>
    <div
      v-if="!isObjEmpty(batch)"
      class="mb-2"
    >
      <h5 class="mb-0">
        Batch: {{ batch.name }}
      </h5>
      <div>
        <p class="mb-0 text-sm d-inline-block">
          (Location:
          {{ `${batch.operation && batch.operation.name}, ${batch.operation.city} ${batch.operation.state ? batch.operation.state.value : ""}` }})
        </p>
        <div
          v-if="batch.operation && batch.operation.state && batch.operation.state.display_med_rec_designations"
          class="d-inline-block"
        >
          <div
            v-if="batch.operation.industry == 'Medical'"
            class="badge-med-rec badge-medical"
            style="width: 34px; padding: 1px"
          >
            Med
          </div>
          <div
            v-else-if="batch.operation.industry == 'Recreational'"
            class="badge-med-rec badge-recreational"
            style="width: 34px; padding: 1px"
          >
            Rec
          </div>
        </div>
      </div>
    </div>
    <div v-if="batch.hold && !onDeckOverride">
      This batch is on deck meaning that it will become available when existing batches have sold out or have been added to your cart. The details for
      this batch will be available when it becomes available for sale.
    </div>
    <div v-else>
      <div>
        <CbdRangeScale
          :batch="batch"
          :category="product.category"
          :predominate-canabinoid="product.predominate_canabinoid"
        />
      </div>
      <div style="overflow: hidden">
        <div class="row">
          <div
            v-if="batch && batch.description"
            class="col-12 col-lg-6"
          >
            <div class="mb-4">
              <span
                v-html-safe="batch.description"
                style="white-space: pre-line"
              />
            </div>
            <div
              v-if="batch && batch.operation && batch.operation.certifications && batch.operation.certifications.length > 0"
              class="mb-3"
            >
              <h5>Certificates</h5>
              <span
                v-for="certification in batch.operation.certifications"
                :key="certification.id"
              >
                <ProductDisplayDocumentsList
                  :documents="certification.documents"
                  :is-downloadable="true"
                  :certification-type="certification.type"
                />
              </span>
            </div>
            <div
              v-if="product.government_agencies && product.government_agencies.length > 0"
              class="mb-3"
            >
              <h5>Government Registrations</h5>
              <ul class="bushel-documents-list">
                <li
                  v-for="agency in product.government_agencies"
                  :key="agency.id"
                >
                  <i
                    v-if="agency.name == 'USDA'"
                    :id="agency.name"
                    class="bushel-icon bushel-ops-usda bushel-3x"
                  />
                  <BTooltip
                    :target="agency.name"
                    placement="top"
                    triggers="hover"
                  >
                    {{ agency.name }}
                  </BTooltip>
                  <i
                    v-if="agency.name == 'PPVA'"
                    :id="agency.name"
                    class="bushel-icon bushel-ops-gov bushel-3x"
                  />
                  <BTooltip
                    :target="agency.name"
                    placement="top"
                    triggers="hover"
                  >
                    {{ agency.name }}
                  </BTooltip>
                  <i
                    v-if="agency.name == 'CPVO'"
                    :id="agency.name"
                    class="bushel-icon bushel-ops-gov bushel-3x"
                  />
                  <BTooltip
                    :target="agency.name"
                    placement="top"
                    triggers="hover"
                  >
                    {{ agency.name }}
                  </BTooltip>
                </li>
              </ul>
            </div>
          </div>

          <div class="col-12">
            <div
              v-if="product.ingredients_upload"
              class="mb-3"
            >
              <a
                :href="product.ingredients_upload ? `/b-api/inventory/ingredients-doc/download/${product.ingredients_upload}` : ''"
                :download="getFileName(product.ingredients_upload)"
              >
                <BushelBtn class="mb-3"> Ingredients List </BushelBtn>
              </a>
            </div>
            <div
              v-if="showProductAdditives && product.additives && product.additives.length > 0"
              class="mb-3"
            >
              <h5>Additives</h5>
              <ul class="list-unstyled">
                <li
                  v-for="additive in product.additives"
                  :key="additive.id"
                >
                  <span v-if="additive.abbreviation">({{ additive.abbreviation }})</span> {{ additive.name }}
                </li>
              </ul>
            </div>
            <ItemTag
              v-if="batch.seeded"
              :name="'Seeded' + ': ' + batch.seeded"
              :tooltip="'Seeded'"
            />
            <div
              v-if="batch && ((batch.documents && batch.documents.length > 0) || (batch.metrc_lab_results && batch.metrc_lab_results.length > 0))"
              class="mb-3"
            >
              <h5>Testing Documents</h5>
              <ProductDisplayDocumentsList
                :documents="batch.documents"
                :lab-results="batch.metrc_lab_results"
                :is-downloadable="true"
              />
            </div>
          </div>
        </div>
      </div>
      <div>
        <ProductDisplayPotencyTab
          :product="product"
          :batch="batch"
        />
      </div>
    </div>
  </div>
</template>
<script>
// import TruncateShowHide from '@/components/common/TruncateShowHide';

import { getFileName, isObjEmpty } from "@/services/helpers";
import { showProductAdditivesCheck } from "@/services/inventory/showProductFieldChecks";
import ProductDisplayDocumentsList from "@/components/common/ProductDisplayDocumentsList.vue";
import CbdRangeScale from "./components/CbdRangeScale.vue";
import ProductDisplayPotencyTab from "./components/ProductDisplayPotencyTab.vue";
import ItemTag from "@/components/common/ItemTag.vue";

export default {
  name: "ProductDisplayDetailsTab",
  components: {
    // TruncateShowHide,
    ProductDisplayPotencyTab,
    ProductDisplayDocumentsList,
    CbdRangeScale,
    ItemTag,
  },
  props: {
    product: { type: Object, required: true },
    batch: { type: Object, required: true },
    onDeckOverride: { type: Boolean, default: false },
  },
  computed: {
    showProductAdditives() {
      return showProductAdditivesCheck(this.product.category);
    },
  },
  methods: {
    getFileName,
    isObjEmpty,
  },
};
</script>
